// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import echarts from 'echarts'
// ie内核兼容性问题， 请不要使用VueParticles
// import VueParticles from 'vue-particles'
import 'font-awesome/css/font-awesome.css'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'element-ui/lib/theme-chalk/reset.css'
import 'styles/index.scss'
import 'icons'
import './permission'
import animate from 'animate.css'
import VueClipboard from 'vue-clipboard2'
Vue.config.productionTip = false
Vue.config.debug = true
Vue.use(VueClipboard)
Vue.use(animate)
Vue.use(ElementUI, {size: 'mini'})
Vue.prototype.$echarts = echarts
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js